import React from 'react';

export function CloseIcon({ width, height, color }) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24">
      <g fill="none" fillRule="nonzero" stroke={color} strokeLinecap="square" strokeWidth="2">
          <path d="M16.95 6.914l-9.9 9.9M16.95 17.107l-9.9-9.9"/>
      </g>
  </svg>;
}
